import { HeroHookSlice as HeroHookSliceType } from '@monofront/types';
import { HeroHook as HeroHookSlice } from '@slices/HeroHook';

export const HeroHook = ({
  prismicContent,
}: {
  prismicContent: HeroHookSliceType;
}) => {
  return <HeroHookSlice slice={prismicContent} />;
};
